<template>
	<div>
		<button
			class="login-menu-button"
			:class="{ 'logged-in': isLoggedIn }"
			:disabled="loading"
			@click="handleLoginClick"
		>
			<FontAwesomeIcon :icon="faUserCog" />
		</button>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { AccountModal, SettingsModal } from '@/lazy-load-components';
import { faUserCog } from '@fortawesome/free-solid-svg-icons';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { ModalHelper } from '@/helpers/vfm/modal-helper';

const { isLoggedIn } = storeToRefs(useUserStore());
const loading = ref(false);

function onWillDismiss() {
	loading.value = false;
}

async function handleLoginClick() {
	loading.value = true;

	if (isLoggedIn.value) {
		await ModalHelper.openModal(SettingsModal, { closable: true, onWillDismiss }, { id: 'settings' });
	} else {
		await ModalHelper.openModal(
			AccountModal,
			{ closable: true, onWillDismiss },
			{ cssClass: 'account-modal' },
			'LoginMenuButton'
		);
	}
}
</script>

<style lang="scss" scoped>
.login-menu-button {
	all: unset;
	display: flex;
	align-items: center;
	height: 100%;
	padding: 0 15px;
	font-size: 16px;

	&.logged-in {
		color: var(--jw-color-primary);
	}
}
</style>
